import { defaultTo, toNumber } from 'lodash';

export function parseInputToNumber(input: string, fallbackValue: number = 0): number {
  return defaultTo(toNumber(input.replace(/\s+/gi, '')), fallbackValue);
}
